<script lang="ts">
	/**
	 * Delays a skeleton until after mount, then fades it in.
	 *
	 * Requests that resolve in a few dozen milliseconds would otherwise flash a
	 * skeleton and rip it away again — worse than showing nothing. Wrapping the
	 * skeleton means fast loads look instant and only genuinely slow ones grow
	 * a placeholder.
	 */
	import { onMount } from 'svelte';
	import { fade } from 'svelte/transition';

	/** Milliseconds to wait before the fade begins. */
	export let delay: number = 100;

	let isSkeletonReady: boolean = false;

	onMount(() => {
		isSkeletonReady = true;
	});
</script>

{#if isSkeletonReady}
	<div transition:fade={{ delay }}>
		<slot />
	</div>
{/if}
